import React from "react";
import { FooterButton, FooterButtonGroup } from "../footer";

export const KonvaPerfButton = ({ onClick, isOn }: { onClick: () => void; isOn: boolean }) => {
  return (
    <FooterButtonGroup>
      <FooterButton tooltip={"KonvaPerfMeter"} onClick={onClick} disabled={false} testid="konva-perf-button">
        <svg width="45px" height="31px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Outer Circle */}
          <circle
            cx="6"
            cy="12"
            r="9"
            stroke={isOn ? "green" : "black"} // Changes color based on `isOn`
            fill={isOn ? "lightgreen" : "none"} // Adds fill if `isOn`
          />

          {/* Inner Lines */}
          <line x1="6" y1="3" x2="6" y2="5" stroke="black" />
          <line x1="10.95" y1="5.05" x2="9.7" y2="6.3" stroke="black" />
          <line x1="13.9" y1="10" x2="12" y2="10" stroke="black" />
          <line x1="13.9" y1="14" x2="12" y2="14" stroke="black" />
          <line x1="10.95" y1="18.95" x2="9.7" y2="17.7" stroke="black" />
          <line x1="6" y1="21" x2="6" y2="19" stroke="black" />
          <line x1="1.05" y1="18.95" x2="2.3" y2="17.7" stroke="black" />
          <line x1="-1.9" y1="14" x2="0" y2="14" stroke="black" />
          <line x1="-1.9" y1="10" x2="0" y2="10" stroke="black" />
          <line x1="1.05" y1="5.05" x2="2.3" y2="6.3" stroke="black" />

          {/* Red Hand */}
          <line
            x1="6"
            y1="12"
            x2="11"
            y2="7"
            stroke={isOn ? "green" : "red"} // Changes color based on `isOn`
            strokeWidth="2"
          />

          {/* Text */}
          <text
            x="21"
            y="23"
            fontFamily="Arial"
            fontSize="6"
            fill={isOn ? "green" : "black"} // Changes text color based on `isOn`
            textAnchor="middle"
          >
            Konva
          </text>
        </svg>
      </FooterButton>
    </FooterButtonGroup>
  );
};
